// extracted by mini-css-extract-plugin
export default {"app":"Contact_app__a9Lho","headerBar":"Contact_headerBar__6yPOc","view":"Contact_view__bmChZ","inputArea":"Contact_inputArea__1yS-6"};